import { CANCEL_NOTICE_AUDIENCE_LABELS } from "../../services/backend/gfunctions/handleCorrespondence/cancelNoticeEmail";

// What the annul dialog says about the email, from the cancelNotice preview the
// function sends with the radicado (planCancelNotice). { severity, text, people,
// reasonNote } — severity "warning" when emails will go out, since the person
// annulling is about to write to people outside the app, "info" otherwise.
export const summarizeCancelNotice = (notice, { finalized }) => {
  if (!finalized || notice?.status === "not_applicable") {
    return {
      severity: "info",
      text: "No se enviará ningún correo: el radicado no se finalizó, así que nunca se envió a nadie.",
      people: [],
      reasonNote: null,
    };
  }
  if (!notice) {
    return {
      severity: "info",
      text: "No se pudo comprobar a quién se notificará. Si la notificación está activada, el correo saldrá al anular.",
      people: [],
      reasonNote: null,
    };
  }
  switch (notice.status) {
    case "disabled":
      return {
        severity: "info",
        text: "No se enviará correo de anulación: la notificación está desactivada en la configuración.",
        people: [],
        reasonNote: null,
      };
    case "no_addresses":
      return {
        severity: "info",
        text: "No se enviará correo de anulación: ninguno de los destinatarios configurados tiene correo.",
        people: [],
        reasonNote: null,
      };
    case "config_unavailable":
      return {
        severity: "warning",
        text: "No se pudo leer la configuración de radicados; es posible que la anulación no se pueda completar ahora.",
        people: [],
        reasonNote: null,
      };
    case "will_send": {
      const people = (notice.addressees || []).map((a) => ({
        key: `${a.audience}:${a.email}`,
        label: a.name ? `${a.name} <${a.email}>` : a.email,
        audience: CANCEL_NOTICE_AUDIENCE_LABELS[a.audience] || a.audience,
      }));
      const count = people.length;
      return {
        severity: "warning",
        text: `Al anular se enviará un correo de anulación a ${count} ${count === 1 ? "persona" : "personas"}:`,
        people,
        reasonNote: notice.includeReason
          ? "El correo incluirá el motivo que escribas abajo."
          : "El correo no incluirá el motivo.",
      };
    }
    default:
      return { severity: "info", text: "", people: [], reasonNote: null };
  }
};
